import styled from 'styled-components'
import CollapseComponent from 'ui/src/components/controls/collapse'
import IconButton from 'ui/src/components/controls/icon-button'

export const Layer = styled.div`
    display: flex;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
`

export const Collapse = styled(CollapseComponent)`
    width: 100%;
`

export const DragButton = styled(IconButton)`
    cursor: grab;
    flex-shrink: 0;
    margin-top: 3px;

    &:active {
        cursor: grabbing;
    }
`
